/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import * as LucideIcons from 'lucide-react'
import { LucideProps } from 'lucide-react'

// Convert feather-style names to PascalCase for Lucide
const toPascalCase = (str: string) =>
    str
        .split('-')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join('')

interface UiIconProps extends Omit<LucideProps, 'ref'> {
    name: string
}

const UiIcon: React.FC<UiIconProps> = ({
    name,
    className,
    strokeWidth = 2,
    ...props
}) => {
    const pascalName = toPascalCase(name)
    // @ts-ignore
    const IconComponent = LucideIcons[pascalName] || LucideIcons.HelpCircle

    return (
        <IconComponent
            className={className ? `UiIcon ${className}` : 'UiIcon'}
            strokeWidth={strokeWidth}
            {...props}
        />
    )
}

export default UiIcon